var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"ndc-app-white-line"}),_c('div',{staticClass:"ndc-app-blue-line"}),_c('div',{staticClass:"active-tab",style:(_vm.topComputed)})])
}
var staticRenderFns = []

export { render, staticRenderFns }